import React from 'react';

// Lib
import { Link } from 'react-router-dom';
import { shallowEqual } from 'react-redux';
import { getDriverInstance } from 'lib/driver';
import { useAppDispatch, useAppSelector } from 'lib/hooks/useDispatch';

// Classnames
import clsx from 'clsx';

// Actions
import * as actionsCreatorThesaurus from 'pages/Thesaurus/reducer';

// Components
import Timer from 'pages/Timer';
import TargetBox from './TargetBox';
import Button from 'components/UiKit/Button';
import FieldText from 'components/UiKit/FieldText';

export const Control: React.FC = () => {
	const dispatch = useAppDispatch();
	const drv = getDriverInstance();

	const { px, tags, loadingBaData: loading } = useAppSelector(
		(store) => store.thesaurus,
		shallowEqual
	);

	const handlerChangeInput = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
		if (+target?.value > 0) {
			dispatch(actionsCreatorThesaurus.handlerChangeInputPx(target.value));
		}
	};

	const handlerClick = () => {
		dispatch(actionsCreatorThesaurus.getBaDataForTargets());

		if(drv?.isActive()) {
			drv?.moveNext();
		}
	};

	const isLimitTags = tags.length < 61;
	const isDisabled = !!tags.length && !!px && isLimitTags;

	const cnNote = clsx(
		'control__note',
		!isLimitTags ? 'control__note--active' : ''
	);

	return (
		<div className="control search-bio__bg mt10 flex-direction-column relative">
			<div className="controll__block flex flex-ai-center flex-jc-between">
				<FieldText
					step="0.1"
					value={px}
					label="pX ≥"
					innerTypeInput="number"
					onChange={handlerChangeInput}
					id="bio-search-target-box-px"
					className="search-bio__input-px flex-direction-row flex-ai-center"
				/>

				<div className="controll__right-block flex flex-ai-start flex-direction-column-reverse-mobile">
					<Timer text="Request time"/>
					<Button
						color="green"
						variable="info"
						label="Get info"
						loading={loading}
						disabled={!isDisabled}
						onPress={handlerClick}
						className="control__btn-request"
						id="bio-search-target-box-get-info"
					/>
				</div>
			</div>

			<TargetBox
				tags={tags}
				isLimit={!isLimitTags}
			/>

			<p className={cnNote}>*Please note you can perform a search of compounds only for 60 targets
				simultaneously. To get information for a broader variety of targets <Link
					to="/contact-us">contact us</Link>.</p>
		</div>
	);
};

export default Control;
